import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=7352464a&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7352464a')) {
      api.createRecord('7352464a', component.options)
    } else {
      api.reload('7352464a', component.options)
    }
    module.hot.accept("./radio-group.vue?vue&type=template&id=7352464a&", function () {
      api.rerender('7352464a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/radio/src/radio-group.vue"
export default component.exports